"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiltersIcon = void 0;
var react_1 = __importStar(require("react"));
var uniqueId_1 = __importDefault(require("lodash/uniqueId"));
var build_svg_icon_1 = require("./build-svg-icon");
exports.FiltersIcon = (0, build_svg_icon_1.buildSvgIcon)(function () {
    var _a = __read((0, react_1.useState)((0, uniqueId_1.default)('filters-mask-0')), 1), mask = _a[0];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("defs", null,
            react_1.default.createElement("mask", { id: mask, x: "0", y: "0", width: "16", height: "12" },
                react_1.default.createElement("rect", { x: "0", y: "0", width: "16", height: "12", fill: "white" }),
                react_1.default.createElement("circle", { cx: "11", cy: "3", r: "2", fill: "black" }),
                react_1.default.createElement("circle", { cx: "5", cy: "9", r: "2", fill: "black" }))),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 4L15 4C15.5523 4 16 3.55228 16 3C16 2.44772 15.5523 2 15 2L1 2C0.447715 2 0 2.44772 0 3C0 3.55228 0.447715 4 1 4Z", fill: "currentColor", mask: "url(#".concat(mask, ")") }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 10L15 10C15.5523 10 16 9.55228 16 9C16 8.44772 15.5523 8 15 8H1C0.447715 8 0 8.44772 0 9C0 9.55228 0.447715 10 1 10Z", fill: "currentColor", mask: "url(#".concat(mask, ")") }),
        react_1.default.createElement("circle", { cx: "11", cy: "3", r: "2", fill: "transparent", stroke: "currentColor", strokeWidth: "2" }),
        react_1.default.createElement("circle", { cx: "5", cy: "9", r: "2", fill: "transparent", stroke: "currentColor", strokeWidth: "2" })));
}, 'FiltersIcon', { viewBox: '0 0 16 12', color: 'transparent' });
exports.default = exports.FiltersIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmlsdGVyc0ljb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9pY29ucy9GaWx0ZXJzSWNvbi50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNkNBQXdDO0FBQ3hDLDZEQUF3QztBQUN4QyxtREFBZ0Q7QUFFbkMsUUFBQSxXQUFXLEdBQUcsSUFBQSw2QkFBWSxFQUNyQztJQUNRLElBQUEsS0FBQSxPQUFTLElBQUEsZ0JBQVEsRUFBQyxJQUFBLGtCQUFTLEVBQUMsZ0JBQWdCLENBQUMsQ0FBQyxJQUFBLEVBQTdDLElBQUksUUFBeUMsQ0FBQztJQUNyRCxPQUFPLENBQ0w7UUFDRTtZQUNFLHdDQUFNLEVBQUUsRUFBRSxJQUFJLEVBQUUsQ0FBQyxFQUFDLEdBQUcsRUFBQyxDQUFDLEVBQUMsR0FBRyxFQUFDLEtBQUssRUFBQyxJQUFJLEVBQUMsTUFBTSxFQUFDLElBQUk7Z0JBQ2hELHdDQUFNLENBQUMsRUFBQyxHQUFHLEVBQUMsQ0FBQyxFQUFDLEdBQUcsRUFBQyxLQUFLLEVBQUMsSUFBSSxFQUFDLE1BQU0sRUFBQyxJQUFJLEVBQUMsSUFBSSxFQUFDLE9BQU8sR0FBRztnQkFDeEQsMENBQVEsRUFBRSxFQUFDLElBQUksRUFBQyxFQUFFLEVBQUMsR0FBRyxFQUFDLENBQUMsRUFBQyxHQUFHLEVBQUMsSUFBSSxFQUFDLE9BQU8sR0FBRztnQkFDNUMsMENBQVEsRUFBRSxFQUFDLEdBQUcsRUFBQyxFQUFFLEVBQUMsR0FBRyxFQUFDLENBQUMsRUFBQyxHQUFHLEVBQUMsSUFBSSxFQUFDLE9BQU8sR0FBRyxDQUN0QyxDQUNGO1FBQ1Asd0NBQ0UsUUFBUSxFQUFDLFNBQVMsRUFDbEIsUUFBUSxFQUFDLFNBQVMsRUFDbEIsQ0FBQyxFQUFDLHNIQUFzSCxFQUN4SCxJQUFJLEVBQUMsY0FBYyxFQUNuQixJQUFJLEVBQUUsZUFBUSxJQUFJLE1BQUcsR0FDckI7UUFDRix3Q0FDRSxRQUFRLEVBQUMsU0FBUyxFQUNsQixRQUFRLEVBQUMsU0FBUyxFQUNsQixDQUFDLEVBQUMseUhBQXlILEVBQzNILElBQUksRUFBQyxjQUFjLEVBQ25CLElBQUksRUFBRSxlQUFRLElBQUksTUFBRyxHQUNyQjtRQUNGLDBDQUNFLEVBQUUsRUFBQyxJQUFJLEVBQ1AsRUFBRSxFQUFDLEdBQUcsRUFDTixDQUFDLEVBQUMsR0FBRyxFQUNMLElBQUksRUFBQyxhQUFhLEVBQ2xCLE1BQU0sRUFBQyxjQUFjLEVBQ3JCLFdBQVcsRUFBQyxHQUFHLEdBQ2Y7UUFDRiwwQ0FDRSxFQUFFLEVBQUMsR0FBRyxFQUNOLEVBQUUsRUFBQyxHQUFHLEVBQ04sQ0FBQyxFQUFDLEdBQUcsRUFDTCxJQUFJLEVBQUMsYUFBYSxFQUNsQixNQUFNLEVBQUMsY0FBYyxFQUNyQixXQUFXLEVBQUMsR0FBRyxHQUNmLENBQ0QsQ0FDSixDQUFDO0FBQ0osQ0FBQyxFQUNELGFBQWEsRUFDYixFQUFFLE9BQU8sRUFBRSxXQUFXLEVBQUUsS0FBSyxFQUFFLGFBQWEsRUFBRSxDQUMvQyxDQUFDO0FBRUYsa0JBQWUsbUJBQVcsQ0FBQyJ9


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/icons/FiltersIcon.js
// module id = 3552
// module chunks = 25